import { v1 } from "@/axios"

interface INotifyUploadCompleteData {
  key: string
  fileName: string
  originalFileName?: string
  fileSize?: number | null
  contentType?: string
}

export async function notifyUploadComplete(data: INotifyUploadCompleteData, eventVaultId: number, albumId?: number) {
  await v1.post(`/upload/${eventVaultId}/complete`, {
    ...data,
    albumId,
  })
}
